<aside [class]="merge('tips-card', cardClass)" [attr.aria-label]="header">
  <header [class]="merge('tips-card__head', headerClass)">
    <span class="bk-sym tips-card__icon" aria-hidden="true">lightbulb</span>
    <h2 class="tips-card__title">{{ header }}</h2>
  </header>

  <dl [class]="merge('tips-card__list', divide ? 'is-divided' : '', tipsClass)">
    @for (tip of tips; track tip.title) {
      <div [class]="merge('tips-card__tip', tipClass)">
        <dt class="tips-card__tip-title">{{ tip.title }}</dt>
        <dd class="tips-card__tip-text">{{ tip.description }}</dd>
      </div>
    }
  </dl>
</aside>
